import Vue from 'vue'
import axios from 'axios'
import { processAthlete } from '@/store/modules/athletes/detail'

// state
export const state = {
  isTeamTopScorersLoading: {},
  all: {},
}

// getters
export const getters = {
  getTeamTopScorers: ({ all }) => (teamId) => all[teamId] || [],
  getIsTeamTopScorersLoading: ({ isTeamTopScorersLoading }) => (teamId) => isTeamTopScorersLoading[teamId] || false,
}
// mutations
export const mutations = {
  fetchTeamTopScorersStarted(state, { teamId }) {
    Vue.set(state.isTeamTopScorersLoading, teamId, true)
  },
  fetchTeamTopScorersSuccess(state, { teamId, scorers }) {
    Vue.set(state.all, teamId, scorers.map((athlete) => processAthlete(athlete)))
    Vue.set(state.isTeamTopScorersLoading, teamId, false)
  },
  fetchTeamTopScorersFailed(state, { teamId }) {
    Vue.set(state.isTeamTopScorersLoading, teamId, false)
  },
}
// actions
export const actions = {
  async fetchTeamTopScorers({ commit, state: { all }, getters }, { teamId }) {
    if (typeof all[teamId] !== 'undefined' || getters.getIsTeamTopScorersLoading(teamId)) {
      return all[teamId]
    }
    let scorers = null
    try {
      commit('fetchTeamTopScorersStarted', { teamId })
      scorers = await axios.get(`team/${teamId}/topScorers/3`)
      commit('fetchTeamTopScorersSuccess', {
        teamId,
        scorers,
      })
    } catch (e) {
      commit('fetchTeamTopScorersFailed', { teamId })
    }
    return scorers
  },
}
